module.exports = __webpack_public_path__ + "media/metronic/_theme/media/logos/logo-2-sm-0cb2b3ebd27d748a270fba99737040e0.png";